// extracted by mini-css-extract-plugin
module.exports = {"content":"_7a3fb80146--content--k07WI","icon-wrapper":"_7a3fb80146--icon-wrapper--zsmIz","heading":"_7a3fb80146--heading--F2H9Q","footer":"_7a3fb80146--footer--fizR5"};